import React from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import InputField from '../../../../Components/Form/components/InputField';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { FormValues } from '../../../MagicForm/Interfaces/FormValues';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import useApiClient from '../../../Base/Hooks/useApiClient';
import apiClient from '../../../../Services/ApiClient';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	onSuccess: () => void;
}

const PatientsGroupsCreateBySelection: React.FC<Props> = ({ onSuccess }) => {
	const { t } = useTranslation();

	const validationScheme = yup.object({
		name: yup
			.string()
			.required(t('validation.patientsGroupsCreateBySelection.name')),
		description: yup.string().max(255).notRequired(),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationScheme),
		defaultValues: {},
	});
	const { displayError } = useApiClient();

	const handleSubmit = (values: FormValues) => {
		try {
			apiClient.post(`/group`, {
				name: values.name,
				description: values.description,
			});
		} catch (e) {
			displayError(e);
		}
		onSuccess();
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<InputField
					name='name'
					label='base.groupName'
					placeholder='base.enterGroupName'
					isRequired
				/>
			</InputWrapper>
			<InputWrapper>
				<TextAreaField
					name='description'
					label='base.addGroupDescription'
					placeholder='base.writeGroupDescription'
					charactersLimit={255}
					showCharCounter
				/>
			</InputWrapper>
			<SubmitButton onSubmit={handleSubmit} />
		</FormWrapper>
	);
};

export default PatientsGroupsCreateBySelection;
